export default [
    {
        path: '',
        name: 'AccountIndex',
        component: () => import('../views/pages/account/AccountIndex.vue'),
        meta: {
            title: 'Moje konto'
        }
    },
    {
        path: 'settings',
        name: 'AccountSettings',
        component: () => import('../views/pages/account/settings/Index.vue'),
        meta: {
            title: 'Ustawienia'
        }
    },
    {
        path: 'localization',
        name: 'AccountLocalization',
        component: () => import('../views/pages/account/localization/Index.vue'),
        meta: {
            title: 'Dane lokalizacyjne'
        }
    },
    {
        path: 'contact',
        name: 'AccountContact',
        component: () => import('../views/pages/account/contact/Index.vue'),
        meta: {
            title: 'Dane kontaktowe'
        }
    },
    {
        path: 'reservations',
        name: 'AccountReservations',
        component: () => import('../views/pages/account/reservations/Index.vue'),
        meta: {
            title: 'Dostępność i Rezerwacje'
        }
    },
    {
        path: 'services',
        name: 'AccountServices',
        component: () => import('../views/pages/account/services/Index.vue'),
        meta: {
            title: 'Usługi i Cennik'
        }
    },
    {
        path: 'opinions',
        name: 'AccountOpinions',
        component: () => import('../views/pages/account/opinions/Index.vue'),
        meta: {
            title: 'Opinie'
        }
    },
    {
        path: 'premium',
        name: 'AccountPremium',
        component: () => import('../views/pages/account/premium/Index.vue'),
        meta: {
            title: 'Widoczność i promowanie profilu'
        }
    }
]
